<template>
  <router-view v-if="applyData"/>
</template>

<script>
import store from '@/store'
import { parse, format, addDays, isBefore } from 'date-fns'
import { mapState } from 'vuex'
import { getOffset, parseJwt } from '@/libs/utils'
import { getAuthToken } from '@/libs/auth-helper'
import { DOCUMENT_TITLE_PREFIX } from '@/libs/constants'
import { getApply } from '@/api/apply'
import { getReportPeriod } from '@/api/report'
import { getDialog } from '@/libs/vue-utils'

const openDialog = getDialog('dialogType')

function loadApplyData (aid, query) {
  return Promise.all([
    getApply(aid),
    getReportPeriod(aid)
  ]).then(result => {
    const apply = result[0]
    const period = result[1]

    if (!apply || !apply.meta.canViewReport) {
      return null
    }

    const tokenData = parseJwt(getAuthToken())
    const userId = tokenData.identity.user_id
    const userNum = tokenData.identity.user_num
    const isAdmin = tokenData.identity.is_admin

    if (userId !== 'admin' && !isAdmin && !apply.meta.shared) {
      if (userId !== apply.userId || userNum !== apply.userNum) {
        return null
      }
    }

    const dateFormat = 'YYYY-MM-DD'
    const minDate = parse(period.minDate)
    const maxDate = parse(period.maxDate)
    let startDate = addDays(maxDate, -6)
    let endDate

    if (isBefore(startDate, minDate)) {
      startDate = parse(minDate)
    }

    if (query.startDate) {
      startDate = parse(query.startDate)
    }

    if (query.endDate) {
      endDate = parse(query.endDate)
    }
    let startDateStr = format(startDate, dateFormat)
    let endDateStr = format(endDate || maxDate, dateFormat)
    let minDateStr = format(minDate, dateFormat)
    let maxDateStr = format(maxDate, dateFormat)

    apply.timezone = getOffset(apply.timezoneName)

    store.commit('setApplyData', apply)
    store.commit('setReportPeriod', {
      start: startDateStr,
      end: endDateStr,
      min: minDateStr,
      max: maxDateStr
    })
    document.title = `Report(${apply.pageName}) | ${DOCUMENT_TITLE_PREFIX}`
    return apply
  })
}

export default {
  name: 'Report',
  mounted () {
    document.title = this.$t('documentTitle.Report', { pageName: this.applyData.pageName }) + ` | ${DOCUMENT_TITLE_PREFIX}`
  },
  computed: {
    ...mapState([
      'applyData'
    ])
  },
  methods: {
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.aid && from.params.aid !== to.params.aid) {
      loadApplyData(to.params.aid, to.query).then(result => {
        if (!result) {
          openDialog('report.invalidRequest').then(() => {
            return next({ name: 'dashboard' })
          })
        } else {
          return next()
        }
      }).catch(err => {
        console.error(err)
        return next({ name: 'dashboard' })
      })
    } else {
      return next()
    }
  },
  beforeRouteEnter (to, from, next) {
    const aid = to.params.aid

    if (!aid) {
      return next({ name: 'dashboard' })
    } else {
      loadApplyData(aid, to.query).then(result => {
        if (!result) {
          openDialog('report.invalidRequest').then(() => {
            return next({ name: 'dashboard' })
          })
        } else {
          return next()
        }
      }).catch(err => {
        console.error(err)
        return next({ name: 'dashboard' })
      })
    }
  }
}
</script>

<style>

</style>
